import React from "react";
import PinDetailMini from "../components/pin-detail-mini";


function GuideOnepiece() {
    return (
        <div className="detail-box">

<h3 align="center">One Piece</h3>

<div className="videotitle">Wave One - 10/19/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1005"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1006"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1007"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1008"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="964"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="965"/></li>
</ul>
<br/>
<div className="videotitle">Nami - 10/19/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1009"/></li>
</ul>
<br/>
<div className="videotitle">Box Set - 11/18/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="984"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="985"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="986"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="987"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="988"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L71"/></li>
</ul>
<br/>
<div className="videotitle">Anime Expo 2023 - 7/1/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1289"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1157"/></li>
</ul>
<br/>
<div className="videotitle">SDCC 2023 - 7/19/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1292"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1299"/></li>
</ul>
<br/>
<div className="videotitle">Alliance Fest SDCC 2023 - 7/20/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1300"/></li>
</ul>
<br/>
<div className="videotitle">Wave Two - 10/5/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1287"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1288"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1158"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1293"/></li>
</ul>
<br/>
<div className="videotitle">NYCC 2023 - 10/12/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1291"/></li>
</ul>
<br/>
<div className="videotitle">Chalice Collectibles - 11/21/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1298"/></li>
</ul>
<br/>
<div className="videotitle">eVend - 1/6/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1290"/></li>
</ul>
        </div>
    );
}

export default GuideOnepiece;


